import React from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
	lifeLog: {
		marginTop: 3,
		width: "80%",
		backgroundColor: "#b3fbff",
	},
}));

const LifeLog = ({ age, content }) => {
	const classes = useStyles();

	return (
		<Paper className={classes.lifeLog}>
			<Typography variant="body1">
				<span role="img" aria-label="cake emoji">
					🎂
				</span>
				Age: <strong>{age} </strong>
				<span role="img" aria-label="cake emoji">
					🎂
				</span>
			</Typography>
			<Typography variant="body2">{content}</Typography>
		</Paper>
	);
};

export default LifeLog;
